import * as types from '@store/types'
import axios from 'axios'

const actions = {
  [types.WITHDRAW]: async ({ dispatch }, payload) => {
    const withdraw_endpoint = payload.endpoint

    switch (payload.pix_type) {
    case 'email':
      payload.pix_email = payload.pix_value
      break
    case 'phone':
      payload.pix_phone = payload.pix_value
      break
    case 'random':
      payload.pix_random = payload.pix_value
      break
    }

    delete payload.endpoint
    delete payload.pix_value
    payload.value *= 100

    try {
      await axios.post(`/${withdraw_endpoint}/withdraw`, payload)

      dispatch(types.FEEDBACK, {
        type: 'success',
        text: 'Saque solicitado com sucesso!'
      })
      return true
    } catch (err) {
      const errorMessage = err.response && err.response.status === 422
        ? 'saldo insuficiente'
        : 'por favor, tente novamente mais tarde'

      dispatch(types.FEEDBACK, {
        type: 'error',
        title: `Houve um erro ao realizar o saque, ${errorMessage}`,
        text: ''
      })
      return false
    }
  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/withdraw.js